import { render, staticRenderFns } from "./LogDataTable.vue?vue&type=template&id=1a45a5d8"
import script from "./LogDataTable.vue?vue&type=script&lang=js"
export * from "./LogDataTable.vue?vue&type=script&lang=js"
import style0 from "./LogDataTable.vue?vue&type=style&index=0&id=1a45a5d8&prod&language=scss&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports